module.exports = __webpack_public_path__ + "img/template_bg.0360d969.png";